import { z } from "zod";
import { apiIntIdSchema } from "./ids.js";
/** Optional group assignment fields shared by create/add-as-contact requests. */
export const contactGroupSelectionFieldsSchema = {
    groupIds: z.array(apiIntIdSchema).optional(),
    newGroupNames: z.array(z.string().trim().min(1).max(120)).optional(),
};
export const contactGroupSelectionSchema = z.object(contactGroupSelectionFieldsSchema);
//# sourceMappingURL=contact-group-selection.js.map